import { lazy } from "react";

const Login = lazy(() => import("../pages/login/Login"));
const Home = lazy(() => import("../pages/home/Home"));
const Orders = lazy(() => import("../pages/orders/Orders"));
const AddUsers = lazy(() => import("../pages/add_users/AddUsers"));
const SellerRegister = lazy(
  () => import("../pages/seller-register/SellerRegister"),
);
const AddReel = lazy(() => import("../pages/add_reel/AddReel"));
const Reels = lazy(() => import("../pages/reels/Reels"));
const DeliverdOrders = lazy(
  () => import("../pages/deliverdOrders/DeliverdOrders"),
);
const Sellers = lazy(() => import("../pages/sellers/Sellers"));
const SetteldOrders = lazy(
  () => import("../pages/SetteldOrders/SetteldOrders"),
);
const Products = lazy(()=>import("../pages/products/Products"));
const AddProduct = lazy(()=>import("../pages/add_product/AddProduct"));

export const routes = [
  {
    path: "/login",
    element: Login,
    exact: true,
    isPublic: true,
  },
  {
    path: "/",
    element: Home,
    exact: true,
  },
  {
    path: "/orders",
    element: Orders,
    exact: true,
  },
  {
    path: "/addUsers",
    element: AddUsers,
    exact: true,
    superAdminOnly: true,
  },
  {
    path: "/register",
    element: SellerRegister,
    exact: true,
    superAdminOnly: true,
  },
  {
    path: "/sellers",
    element: Sellers,
    exact: true,
  },
  {
    path: "/addReel",
    element: AddReel,
    exact: true,
  },
  {
    path: "/reels",
    element: Reels,
    exact: true,
  },
  {
    path: "/DeliverdOrders",
    element: DeliverdOrders,
    exact: true,
  },
  {
    path: "/setteldOrders",
    element: SetteldOrders,
    exact: true,
    superAdminOnly: true,
  },
  {
    path: "/products",
    element: Products,
    exact: true,
    superAdminOnly: true,
  },
  {
    path: "/addProduct",
    element: AddProduct,
    exact: true,
    superAdminOnly: true,
  },
];
